import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IClientPortalUsersService } from "services/ClientPortalUsersService";
import { ClientPortalUserModel } from "services/api/cplauthapi/CPLAuthAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";

const initialState = {
  ClientPortalUsers: new Array<ClientPortalUserModel>(),
  LoadingClientPortalUsers: false,
};

export const clientPortalUsersTableSlice = createSlice({
  name: "clientPortalUsers",
  initialState,
  reducers: {
    resetData: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getClientPortalUsers.pending, (state) => {
        state.LoadingClientPortalUsers = true;
      })
      .addCase(getClientPortalUsers.fulfilled, (state, action) => {
        state.ClientPortalUsers = action.payload;
        state.LoadingClientPortalUsers = false;
      })
      .addCase(getClientPortalUsers.rejected, (state) => {
        state.LoadingClientPortalUsers = false;
      });
  },
});

export const { resetData } = clientPortalUsersTableSlice.actions;

export const getClientPortalUsers = createAsyncThunk("clientPortalUsers/GetClientPortalUsers", async () => {
  const clientPortalUsersService = container.get<IClientPortalUsersService>(SERVICE_TYPES.ClientPortalUsersService);
  return await clientPortalUsersService.getClientPortalUsers();
});

export const selectClientPortalUsers = (state: RootState) => state.clientPortalUsers.ClientPortalUsers;
export const selectLoadingClientPortalUsers = (state: RootState) => state.clientPortalUsers.LoadingClientPortalUsers;

export default clientPortalUsersTableSlice.reducer;
